import { html } from '@utilities/dom-elements'
import { removeChildren } from '@utilities/remove-children'
import { getParams } from '@utilities/url-parameters'

const motions = () => {
  const menuButton = document.querySelector('[js-hook-menulink]')
  const closeButton = document.querySelector('.motion__close')
  const motionContainer = document.querySelector('.motion__container')
  const programmeBlocks = [...document.querySelectorAll('.programme__block, .search__results')]
  const hidden = 'u-hidden'
  const motionIsActive = 'motion--is-active'
  const programmeIsActive = 'programme--is-active'
  const menuIsActive = 'menu--is-active'

  /* Fetch motions filtered by time and location;
     template: motions.php */
  const motionFetch = async (time, location, start) => {
    /* POST method requires data as FormData */
    const formData = new FormData()
    formData.append('time', time)
    formData.append('location', location)
    formData.append('start', start)

    /* Config data for Fetch request. Given headers are
       permitted by Kirby */
    const config = {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    }

    const res = await fetch('/motions', config)

    if (res.status !== 200) throw Error("Something is wrong! We can't get any motions!")

    const data = await res.text()

    renderMotions(data)
  }

  const renderMotions = (data) => {
    motionContainer.insertAdjacentHTML('afterbegin', data)
    html.classList.add(motionIsActive)
    closeButton.classList.remove(hidden)
  }

  /* onload event in case a user comes on website
     through a QR-code (with given parameters) */
  window.addEventListener('load', () => {
    const params = getParams(window.location.href)

    if (Object.keys(params).length !== 0 && params.location !== undefined) {
      const date = new Date()
      const hours = date.getHours()
      let timestamp

      if (hours < 4) {
        timestamp = new Date(date.setHours(hours))
      } else if (hours === 4) {
        timestamp = new Date(date.setHours(hours - hours))
      } else {
        /* Timeblocks with data are from 00:00 till 04:00,
           so if it's 13:00 we want data from block 01:00  */
        timestamp = new Date(date.setHours(hours % 4))
      }



      /* Round minutes down to each quarter */
      const minutes = (Math.floor(timestamp.getMinutes() / 15) * 15)
      const currentTime = `0${timestamp.getHours()}:${minutes !== 0 ? minutes : minutes + '0'}`

       const startHours = ("0" + hours).slice(-2);

      const startTime = `${startHours}:${minutes !== 0 ? minutes : minutes + '0'}`;

      motionFetch(currentTime, params.location, startTime)
    }
  })

  programmeBlocks.forEach(programmeBlock => {
    programmeBlock.addEventListener('click', event => {
      const target = event.target && event.target.closest('[js-hook-motion]');
      if (target) {
        const time = target.getAttribute('data-time')
        const location = target.getAttribute('data-location')
        const startTime = target.getAttribute('data-start')
        const activeProgramme = document.querySelector(`.${programmeIsActive}`)

        if (html.classList.contains(menuIsActive)) html.classList.remove(menuIsActive)

        /* Empty the motion container */
        removeChildren(motionContainer)

        if (target.classList.contains(programmeIsActive)) {
          target.classList.remove(programmeIsActive)
          html.classList.remove(motionIsActive)
          closeButton.classList.add(hidden)
        } else {
          target.classList.add(programmeIsActive)

          motionFetch(time, location, startTime)
        }

        if (activeProgramme !== null) activeProgramme.classList.remove(programmeIsActive)
      }
    })
  })

  Array(closeButton, menuButton).forEach(element => {
    element.addEventListener('click', () => {
      const activeProgramme = document.querySelector(`.${programmeIsActive}`)

      if (activeProgramme !== null) activeProgramme.classList.remove(programmeIsActive)

      html.classList.remove(motionIsActive)
      closeButton.classList.add(hidden)
    })
  })

}

export default motions


// WEBPACK FOOTER //
// /Users/sandersturing/Sites/SD/demo.test/frontend/source/javascript/components/motions.js